import { GENDERS } from 'constants/dictionaries';

import type { TDadataGender } from 'shared/types/TDaData';

export const dadataGenderToCreditForm = (value: TDadataGender) => {
  return (
    Object.values(GENDERS).find((item) => item.toLowerCase() === String(value).trim().toLowerCase()) || GENDERS.UNKNOWN
  );
};

export const creditFormGenderToDadata = (value: ValuesOf<typeof GENDERS>): TDadataGender => {
  return String(value).toUpperCase() as TDadataGender;
};
